/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFolderTrees.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Folder Trees
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 20, 2019 - 12:07 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      03/20/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    CMS_OPEN_CMSSELECT,
    CMS_CLOSE_CMSSELECT,
    CMS_LOAD_CMSSELECT,
    FOLDER_CONTENTS_LOADED
} from '../constants/actionTypeFolderTrees';

const defaultState = {
    folderContents: null,
    folderid: 0,
    cmsTagName: '',
    cmsType: '',
    cmsselect: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CMS_OPEN_CMSSELECT:
            return {
                ...state,
                cmsTagName: action.payload ? action.payload.cmsTagName : '',
                cmsType: action.payload ? action.payload.cmsType : '',
                cmsselect: true
            }
        case CMS_CLOSE_CMSSELECT:
            return {
                ...state,
                cmsTagName: '',
                cmsType: '',
                cmsselect: false
            }
        case CMS_LOAD_CMSSELECT:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                folders: action.payload[0] ? action.payload[0].records : null,
                folderTree: action.payload[1] ? action.payload[1].records : null
            }
        case FOLDER_CONTENTS_LOADED:
            return {
                ...state,
                folderContents: action.payload[0] ? action.payload[0].records : null,
                folderid: action.payload[0] ? action.payload[0].folderid : 0
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFolderTrees.js